import React from 'react'
import { useIntl } from 'react-intl'
import { IconRegularPinterest, IconRegularTiktok, IconRegularYoutube } from '@notino/react-styleguide'
import { SalonDetail } from '../../../../types/types'
import GlobeIcon from '../../../../assets/icons/GlobeIcon'
import FacebookIcon from '../../../../assets/icons/FacebookIcon'
import InstagramIcon from '../../../../assets/icons/InstagramIcon'
import { SOCIAL_LINK_VARIANT } from './SocialIconsStyles'
import * as SC from './SocialIconsStyles'

type Props = {
	salonData: SalonDetail
	variant?: SOCIAL_LINK_VARIANT
}

const SocialIcons = ({ salonData, variant = SOCIAL_LINK_VARIANT.LIGHT }: Props) => {
	const { formatMessage } = useIntl()
	const salonName = salonData.name

	const getSocialAriaLabel = (messageId: string, networkFallback: string) =>
		salonName ? formatMessage({ id: messageId, defaultMessage: messageId }, { salonName }) : networkFallback

	return (
		<SC.Container>
			{salonData.socialLinkWebPage && (
				<SC.SocialLink
					$variant={variant}
					target='_blank'
					href={salonData.socialLinkWebPage}
					rel={'nofollow noopener noreferrer'}
					aria-label={getSocialAriaLabel('Website of salon {salonName}', 'Website')}
				>
					<GlobeIcon aria-hidden />
				</SC.SocialLink>
			)}
			{salonData.socialLinkFB && (
				<SC.SocialLink
					$variant={variant}
					target='_blank'
					href={salonData.socialLinkFB}
					rel={'nofollow noopener noreferrer'}
					aria-label={getSocialAriaLabel('Facebook of salon {salonName}', 'Facebook')}
				>
					<FacebookIcon aria-hidden />
				</SC.SocialLink>
			)}
			{salonData.socialLinkInstagram && (
				<SC.SocialLink
					$variant={variant}
					target='_blank'
					href={salonData.socialLinkInstagram}
					rel={'nofollow noopener noreferrer'}
					aria-label={getSocialAriaLabel('Instagram of salon {salonName}', 'Instagram')}
				>
					<InstagramIcon aria-hidden />
				</SC.SocialLink>
			)}
			{salonData.socialLinkPinterest && (
				<SC.SocialLink
					$variant={variant}
					target='_blank'
					href={salonData.socialLinkPinterest}
					rel={'nofollow noopener noreferrer'}
					aria-label={getSocialAriaLabel('Pinterest of salon {salonName}', 'Pinterest')}
				>
					<IconRegularPinterest color={'icon.inverse'} aria-hidden />
				</SC.SocialLink>
			)}
			{salonData.socialLinkYoutube && (
				<SC.SocialLink
					$variant={variant}
					target='_blank'
					href={salonData.socialLinkYoutube}
					rel={'nofollow noopener noreferrer'}
					aria-label={getSocialAriaLabel('YouTube of salon {salonName}', 'YouTube')}
				>
					<IconRegularYoutube color={'icon.inverse'} aria-hidden />
				</SC.SocialLink>
			)}
			{salonData.socialLinkTikTok && (
				<SC.SocialLink
					$variant={variant}
					target='_blank'
					href={salonData.socialLinkTikTok}
					rel={'nofollow noopener noreferrer'}
					aria-label={getSocialAriaLabel('TikTok of salon {salonName}', 'TikTok')}
				>
					<IconRegularTiktok color={'icon.inverse'} aria-hidden />
				</SC.SocialLink>
			)}
		</SC.Container>
	)
}

export default SocialIcons
